import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control: any;
    error?: any;
    decimalScale?: number;
    maxLength?: number;
    noThousandSeparator?: boolean;
    allowNegative?: boolean;
    disabled?: boolean;
    result?: any;
    onChange?: any;
    onBlur?: any;
}

const MaterialTextField = (props: any) => {
    return (
        <TextField
            {...props}
            id={props.id}
            value={props.result ? props.result : props.value}
            fullWidth
            label={props.label}
            error={!!props.error && !!props.error[props.name]}
            helperText={!!props.error && props.error[props.name]?.message}
            size="small"
            margin="normal"
            disabled={props.disabled}
            inputProps={{
                maxLength: props.maxLength,
            }}
        />
    );
};

const inputNumber: React.FC<IFormInput> = ({
    id,
    name,
    label,
    control,
    error,
    decimalScale,
    maxLength,
    noThousandSeparator,
    allowNegative,
    disabled,
    onChange,
    ...rest
}) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value, onBlur } }) => {
                return (
                    <NumberFormat
                        id={id}
                        value={value}
                        onBlur={onBlur}
                        onValueChange={(item) => renderChange(item.formattedValue)}
                        {...rest}
                        name={name}
                        error={error}
                        label={label}
                        maxLength={maxLength}
                        disabled={disabled}
                        customInput={MaterialTextField}
                        thousandSeparator={noThousandSeparator ? "" : "."}
                        decimalSeparator={","}
                        decimalScale={decimalScale || 0}
                        allowNegative={allowNegative === true ? true : false}
                    />
                );
            }}
        />
    );
};

export default inputNumber;
